import { render, staticRenderFns } from "./NotificationsForecastPreviewCard.vue?vue&type=template&id=98c523b2"
import script from "./NotificationsForecastPreviewCard.vue?vue&type=script&lang=js"
export * from "./NotificationsForecastPreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports